// @flow
import * as React from 'react';
import ClickOutside from 'react-click-outside';
import classnames from 'classnames';

type ObjectMap = { className?: string, style?: Object } & { [string]: * };
type renderProps = {
  isOpen: boolean,
  getProps: (o?: ObjectMap) => ObjectMap,
};
type MenuProps = {
  id?: string,
  label: string,
  justify?: 'left' | 'right',
  renderIcon?: renderProps => *,
  renderItems: renderProps => *,
};
type MenuState = {
  isOpen: boolean,
};

export default class Menu extends React.Component<MenuProps, MenuState> {
  state = {
    isOpen: false,
  };
  button: ?HTMLButtonElement;
  list: ?HTMLUListElement;

  handleClickOutside = () => {
    this.setState({ isOpen: false });
  };

  open = () => {
    this.setState({ isOpen: true });
  };

  componentDidUpdate() {
    if (this.button && this.list) {
      this.list.style.minWidth = this.button.offsetWidth + 'px';
    }
  }

  getIconProps = (props: ObjectMap = {}) => {
    const _className = props.className || '';
    const _style = props.style || {};

    return {
      ...props,
      className: 'v-mid mr2 ' + _className || '',
      style: { height: '1.35rem', width: '1.35rem', ..._style },
    };
  };

  getItemProps = (props: ObjectMap = {}) => {
    return {
      ...props,
      role: 'menuitem',
      tabIndex: 0,
      className: `link db ph3 v-mid bg-animate hover-bg-near-white gray hover-mid-gray ${props.className ||
        ''}`,
      style: { height: '2.5rem', lineHeight: '2.5rem' },
    };
  };

  render() {
    const { isOpen } = this.state;
    const menuButtonCls = classnames(
      'button-reset pointer cb nowrap lh-solid pv2 ph0 ml3 bg-animate bn br2 outline-0',
      'bg-transparent gray hover-blue'
    );
    const label = this.props.label;
    const icon =
      typeof this.props.renderIcon === 'function'
        ? this.props.renderIcon({ isOpen, getProps: this.getIconProps })
        : null;
    const items = this.props.renderItems({
      isOpen,
      getProps: this.getItemProps,
    });
    const listClassName = classnames(
      'list pl0 pv2 ma0 bg-white ba0 b--moon-gray br2 nt1 z-999 absolute',
      {
        'right-0': this.props.justify === 'right',
        'left-0': this.props.justify === 'left',
      }
    );
    const menuStyle = {
      visibility: isOpen ? 'visible' : 'hidden',
      top: '3rem',
      right: '0',
      boxShadow: '0 0 1px hsla(0,0%,7%,.3), 0 10px 25px -4px hsla(0,0%,7%,.4)',
    };

    return (
      <div className="relative" id={this.props.id || ''}>
        <ClickOutside onClickOutside={this.handleClickOutside}>
          <button
            className={menuButtonCls}
            ref={ref => (this.button = ref)}
            type="button"
            onClick={this.open}
            onFocus={this.open}
          >
            {icon}
            <span
              className="v-mid mr2"
              data-translate={this.props.id === 'help-menu' ? true : false}
            >
              {label}
            </span>
            <i
              className="fa v-mid fa-angle-down"
              aria-hidden="true"
              style={{
                fontSize: '1.8rem',
                transform: 'scaleX(0.9)',
              }}
            />
          </button>
          <ul
            role="menu"
            aria-haspopup="true"
            tabIndex="-1"
            className={listClassName}
            style={menuStyle}
            ref={ref => (this.list = ref)}
            data-translate={true}
          >
            {items.map(item => (
              <li key={item.key}>{item}</li>
            ))}
          </ul>
        </ClickOutside>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/__components__/Menu.js